export { View as ReferralPartners } from './view'
